import React from 'react';
import {motion} from 'framer-motion';

const About=()=> {
  return (
    <section id="chi-sono" className="py-32 bg-dark-800 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          
          {/* Image Side */}
          <motion.div 
            initial={{opacity: 0, x: -50}} 
            whileInView={{opacity: 1, x: 0}} 
            viewport={{once: true}} 
            transition={{duration: 0.8}}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-sm overflow-hidden relative grayscale hover:grayscale-0 transition-all duration-700 border border-white/5">
              <img 
                src="https://i.imghippo.com/files/xVwg6635zz.jpg" 
                alt="Lorenzo Brumana" 
                className="w-full h-full object-cover" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-900 via-transparent to-transparent opacity-60"></div>
            </div>
            <div className="absolute -bottom-8 -right-8 bg-gold-500 p-10 hidden md:block">
              <p className="text-black font-black text-6xl leading-none">BL</p>
              <p className="text-black text-[11px] uppercase font-black tracking-[0.4em] mt-2">Performance</p>
            </div>
          </motion.div>

          {/* Text Side */}
          <motion.div 
            initial={{opacity: 0, x: 50}} 
            whileInView={{opacity: 1, x: 0}} 
            viewport={{once: true}} 
            transition={{duration: 0.8, delay: 0.2}}
          >
            <div className="flex items-center space-x-4 mb-8">
              <span className="h-[2px] w-12 bg-gold-500"></span>
              <span className="text-gold-500 uppercase tracking-[0.3em] text-xs font-black">Chi Sono</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-black text-white mb-10 tracking-tighter uppercase leading-none">
              L'APPROCCIO <br/> <span className="text-gray-600 italic">SCIENTIFICO.</span>
            </h2>
            
            <div className="space-y-8 text-gray-400 font-bold text-lg leading-relaxed tracking-tight">
              <p>
                Mi chiamo <strong className="text-white font-black">Brumana Lorenzo</strong> e sono uno studente di Scienze Motorie con una forte passione per la performance e la qualità del movimento.
              </p>
              <p>
                Il mio percorso nasce dall’esperienza diretta sul campo e in palestra. Gioco a calcio, mi alleno costantemente e ho imparato quanto sia fondamentale un approccio strutturato: non solo forza, ma anche mobilità, controllo e prevenzione degli infortuni.
              </p>
              <p>
                <strong className="text-white font-black uppercase">BL.Performance</strong> nasce con un’idea semplice: costruire atleti e persone che non siano solo più forti, ma più efficienti, consapevoli e duraturi nel tempo.
              </p>
            </div>

            <div className="mt-16 grid grid-cols-2 gap-10 border-t border-white/10 pt-10">
              <div>
                <h4 className="text-white text-2xl font-black mb-3 uppercase tracking-tighter">STUDIO</h4>
                <p className="text-sm text-gray-500 font-bold leading-relaxed uppercase tracking-tight">Unione di teoria accademica e pratica costante sul campo.</p>
              </div>
              <div>
                <h4 className="text-white text-2xl font-black mb-3 uppercase tracking-tighter">METODO</h4>
                <p className="text-sm text-gray-500 font-bold leading-relaxed uppercase tracking-tight">Progressioni solide basate sulla fisiologia umana.</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;